module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"Percentage":"Pourcentage","ProjectsName":"Nom des projets","RejectedCount":"Nombre rejetés","TotalCount":"Nombre total"}}')
  delete Component.options._Ctor
}
